import axios from 'axios'

export default {
    searchV2 (
        query,
        types = [],
        subcategories = [],
        from = null,
        to = null,
        sortDirection = 'desc',
        sortType= 'chronological',
        limit = null
    ) {
        return axios.post('/api/search/v2', {
            query: query,
            limit: limit,
            sort_direction: sortDirection,
            sort_type: sortType,
            types: types,
            subcategories: subcategories,
            from: from,
            to: to,
        })
    },

    categories(){
        return axios.get('/api/categories');
    }
}
